import { Empty, Select } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GrispiInputProps } from '..';
import useTagSearch from '../../../hooks/ticketDetailPage/useTagSearch';
import useDebounce from '../../../hooks/useDebounce';
import LoadingMenu from '../../LoadingMenu';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiTagInputProps = Omit<GrispiInputProps<'TAG'>, 'type' | 'options'>;

const initialSearchTerm = '';

const transformTagValue = (value: string[]) => {
    if (Array.isArray(value)) return value.join(',');
    return null;
};

const transformFormValue = (value: string) => {
    if (value && typeof value === 'string') return value.split(',');
};

const GrispiTagInput = ({
    antdProps,
    containerProps,
    isNewValueAllowed: _isNewValueAllowed, // always true
    onChange,
    value,
    ...rest
}: GrispiTagInputProps) => {
    const { t } = useTranslation('forms');

    const [searchTerm, setSearchTerm] = useState<string>(initialSearchTerm);
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const { data: searchResult, isLoading } = useTagSearch(debouncedSearchTerm);

    const notFoundContent = isLoading ? (
        <LoadingMenu />
    ) : debouncedSearchTerm === initialSearchTerm ? (
        t('autocomplete.empty')
    ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    );

    return (
        <GrispiInputContainer {...containerProps}>
            <Select<string[]>
                tokenSeparators={[',', ' ']}
                showSearch
                {...antdProps}
                popupClassName="tickets-tags"
                filterOption={false}
                loading={isLoading}
                mode="tags"
                notFoundContent={notFoundContent}
                onBlur={() => setSearchTerm(initialSearchTerm)}
                onChange={(v) => onChange(transformTagValue(v))}
                onSearch={(value) => setSearchTerm(value)}
                optionLabelProp="label"
                options={isLoading ? [] : searchResult}
                value={transformFormValue(value)}
                {...rest}
            />
        </GrispiInputContainer>
    );
};

export default GrispiTagInput;
